import { defineSlotRecipe } from "@chakra-ui/react";

export const tooltipSlotRecipe = defineSlotRecipe({
  slots: ["root", "trigger", "positioner", "content", "arrow", "arrowTip"],
  className: "chakra-tooltip",
  base: {
    content: {
      "--tooltip-bg": "var(--euka-colors-base-800)",
      bg: "var(--tooltip-bg)",
      color: "base.200",
      p: "8px",
      borderRadius: "4px",
      fontWeight: "medium",
      justifyContent: "center",
      alignItems: "center",
      flexDirection: "row",
      textStyle: "body.standard",
      textAlign: "center",
      boxShadow: "md",
      maxW: "192px",
      zIndex: "tooltip",
      transformOrigin: "var(--transform-origin)",
      _open: {
        animationStyle: "scale-fade-in",
        animationDuration: "fast",
      },
      _closed: {
        animationStyle: "scale-fade-out",
        animationDuration: "fast",
      },
    },
    arrow: {
      "--arrow-size": "sizes.2",
      "--arrow-background": "var(--tooltip-bg)",
    },
    arrowTip: {
      borderTopWidth: "1px",
      borderInlineStartWidth: "1px",
      borderColor: "var(--tooltip-bg)",
    },
  },
});

export default tooltipSlotRecipe;
